import React, { useEffect, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import clsx from 'clsx';
import WabliAppBar from '../WabliAppbar/WabliAppBar';
import DataModelCanvas from './DataModelCanvas';
import ViewPageDataModelBreadcrumb from './ViewPageDataModelBreadcrumb';
import AuthContext  from '../AppAuthContext';
import loadPagesInfo from '../BuildApps/LoadPagesInfo';

const ViewPageDataModel = () => {
  const [init, setInit] = React.useState(false);
  const { state } = useContext(AuthContext);
  const [selectedProject, setSelectedProject] = React.useState();
  const [selectedPage, setSelectedPage] = React.useState();
  const [loadPages, setLoadPages] = React.useState(false);
  const [lockFirstTime, setLockFirstTime] = React.useState(false);

  useEffect(() => {
    if (init === false) {
      setInit(true);
      const tempSelectedProject = JSON.parse(localStorage.getItem('selectedProject'));
      const tempSelectedPage = JSON.parse(localStorage.getItem('selectedPage'));
      setSelectedPage(parseInt(tempSelectedPage, 10));
      setSelectedProject(parseInt(tempSelectedProject, 10));
    }
  }, [init]);

  useEffect(() => {
    if (selectedProject === undefined) return;
    setLockFirstTime(true);
    setLoadPages(true);
    if (lockFirstTime === false) return;
    loadPagesInfo(setLoadPages);
  }, [selectedProject]);

  // redirect to login screen
  if (!state.isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <WabliAppBar />
      <ViewPageDataModelBreadcrumb
        selectedPage={selectedPage}
        setSelectedPage={setSelectedPage}
        selectedProject={selectedProject}
        setSelectedProject={setSelectedProject}
        loadPages={loadPages}
        setLoadPages={setLoadPages}
      />
      <div style={{ backgroundColor: '#12416B ', height: '100%' }}>
        <div className={clsx('generalMarg')} style={{ paddingTop: '2vw', paddingBottom: '2vw' }}>
          <DataModelCanvas selectedPage={selectedPage} selectedProject={selectedProject} />
        </div>
      </div>
    </>
  );
};

export default ViewPageDataModel;
